import React, {
  useState,
} from 'react';

import {
  Flex,
} from 'web-styled';

import Link from '../Link';
import * as S from '../styled';

interface Item {
  id?: number
  link: string
  icon?: string
  name: string
  level?: number
  requiresPremium?: boolean
};

type Props = {
  isFolder?: boolean;
  badge?: string;
  children?: Item[];
  onClick?: { (e: any): void }
} & Item;

const SidebarItem = React.forwardRef<HTMLDivElement, Props>(({
  id = 0,
  link,
  icon,
  name,
  badge,
  isFolder,
  children,
  requiresPremium,
  onClick,
  ...rest
}: Props, ref) => {
  const level = rest.level || 0;
  const [isOpen, setOpen] = useState(false);

  const basePath = isFolder ? `${link}_folder` : link;
  const to = `/${basePath}${id ? `/${id}` : ''}`;

  return (
    <Flex
      column
      width="100%"
      shrink="0"
      ref={ref}
      {...rest}
    >
      <Link
        to={to}
        icon={icon}
        name={name}
        level={level || 0}
        badge={badge}
        isOpen={isOpen}
        isFolder={isFolder}
        requiresPremium={requiresPremium}
        hasChild={children?.length > 0 && !requiresPremium}
        onClick={onClick}
        setOpen={setOpen}
      />

      {isOpen && (
        <S.Sub
          isOpen={isOpen}
          showLine={isFolder && level > 0}
          leftLine={`${level > 1 ? (level * 35) - 21 : 21}px`}
        >
          {children.map(item => (
            <SidebarItem
              key={item.id || item.link}
              link={item.link || link}
              level={level ? level + 1 : 1}
              icon={icon}
              {...item}
            />
          ))}
        </S.Sub>
      )}
    </Flex>
  );
});

export default SidebarItem;
